/*
              _
             | |
             | |===( )   //////
             |_|   |||  | o o|
                    ||| ( c  )                  ____
                     ||| \= /                  ||   \_
                      ||||||                   ||     |
                      ||||||                ...||__/|-"
                      ||||||             __|________|__
                        |||             |______________|
                        |||             || ||      || ||
                        |||             || ||      || ||
------------------------|||-------------||-||------||-||-------
                        |__>            || ||      || ||

     Good idea to check source code!
*/

/* bootstraping */
let isMuteActive = false;

const magicNumber = 13; // 🏴‍☠️ 🦜
const salt = '🧂';
const pepper = '🌶️';
const foo = 'fbab9bf34ca13fe5ca228d9c51ba94c09b35ab2d6fa149ab528eece3db3b272';
const bar = '604ad3d596bc871c2d69f9ab1c3473a6fccbf6d99cd6f14eca16fdf40167fc3';

// Boostraping Local Storage 
if(localStorage.getItem('isAudioMuted') === null) {
  localStorage.setItem('isAudioMuted', JSON.stringify(false));
} else {
  isMuteActive = JSON.parse(localStorage.getItem('isAudioMuted'));

  if(isMuteActive) {
    const audioControl = document.querySelector('#audio-control');
    audioControl.classList.add('audio--off');
  }
}

// Boostraping music
const backgroundAudio = new Audio(require("url:../audio/background_ambient.mp3"));
backgroundAudio.volume = 0.15;
backgroundAudio.loop = true;

const clickTrack = require("url:../audio/click.mp3");
const clickAudio = new Audio(clickTrack);

// Application
const handleButtonClick = ({ target }) => {
  const { digitId, action } = target.dataset;
  const digit = document.querySelector(`div[data-digit-id='${digitId}']`);

  clickAudio.play();
  clickAudio.currentTime = 0;

  if(parseInt(digit.dataset.digitValue) === 0 && action === 'decrement') {
    digit.dataset.digitValue = 9;
  } else if (parseInt(digit.dataset.digitValue) === 9 && action === 'increment') {
    digit.dataset.digitValue = 0;
  } else if(action === 'increment') {
    digit.dataset.digitValue = parseInt(digit.dataset.digitValue) + 1;
  } else if(action === 'decrement') {
    digit.dataset.digitValue = parseInt(digit.dataset.digitValue) - 1;
  }

  digit.innerHTML = digit.dataset.digitValue;
};

/*
  ... is there an easy way? Probably not 🤔
   ▄▄▄▄▄▄▄  ▄     ▄▄▄▄▄▄ ▄▄▄▄▄▄▄  
   █ ▄▄▄ █ ▀█▄█▀ ▀▀   ▄█ █ ▄▄▄ █  
   █ ███ █ ▀▀▄▀▄ ██▄███▄ █ ███ █  
   █▄▄▄▄▄█ █ █ ▄ █▀█▀▄ █ █▄▄▄▄▄█  
   ▄▄▄▄▄ ▄▄▄▄▄ █▄▄▀▄▄ ▀ ▄ ▄ ▄ ▄   
    ▀  ▀ ▄ ██ ▄▄ ▀██▄ ▀▀▄█▀▀   ▀  
   ██▀█▀▀▄█▄█▀█  █▀▀▄ █▀  ▀ █▄▀   
   ▀▀▀▄█ ▄██▄▀ ▀▀▀▄▄ █▀▄▀█▄▀▄▄ ▀  
   ▄▄▀▄▄▀▄▀█▄▀ █ ▄ ▀▄  ▀ ▀█▀▄▄▀   
   █ ▄ ▀▄▄█▄▄█▄▄██▄█  ▀▀ ▀█▀ █ ▀  
   █ ▀██▀▄▀██▀█  █▀█▄▀▀▄▄▄██ ▄█▄  
   ▄▄▄▄▄▄▄ █ █ ▀█▀▄ ▄█▄█ ▄ ███▀▀  
   █ ▄▄▄ █ ▄▀▀ █ ▄▄█▄ ▀█▄▄▄█ ▄▄█  
   █ ███ █ ██ ▄▄ █▄█▀██  ▄█▄███▀  
   █▄▄▄▄▄█ ██ █▄ ▀ █▄██▀▄ █▄█▄▀   
*/

// I like being dirty function 💩!
const getSomeStuff = async awesomeNamingForParam => {
  let codeBuffer = new TextEncoder("utf-8").encode([awesomeNamingForParam, salt, pepper].join(''));

  for (let i = 0; i < magicNumber; i++) {
    const result = await crypto.subtle.digest("SHA-512", codeBuffer);
    codeBuffer = new Uint8Array(result);
  }

  return Array.prototype.map.call(codeBuffer, result => result.toString(16)).join("");
};

const checkSomeStuff = async () => {
  const combination = [
    document.querySelector(`div[data-digit-id='0']`),
    document.querySelector(`div[data-digit-id='1']`),
    document.querySelector(`div[data-digit-id='2']`),
    document.querySelector(`div[data-digit-id='3']`),
  ];

  const combinationNumber = combination.reduce((number, digit) => number.toString() + digit.dataset.digitValue.toString(), '');

  const targetStuff = await getSomeStuff(`${foo}${bar}`);
  const currentStuff = await getSomeStuff(await getSomeStuff(combinationNumber));

  if(targetStuff === currentStuff) {
    const winModal = document.getElementById('modal');

    const modal = bootstrap.Modal.getOrCreateInstance(winModal);

    const combination = [
      document.querySelector(`div[data-digit-id='0']`),
      document.querySelector(`div[data-digit-id='1']`),
      document.querySelector(`div[data-digit-id='2']`),
      document.querySelector(`div[data-digit-id='3']`),
    ];
  
    const combinationNumber = combination.reduce((number, digit) => number.toString() + digit.dataset.digitValue.toString(), '');

    modal.show();

    // We need this on purpose to block event loop
    alert('WIN, number is: ' + combinationNumber);
  }
};

// Event Listeners
const buttons = document.querySelectorAll('button[data-digit-id]');
const audioControl = document.querySelector('#audio-control');

buttons.forEach(button => {
  button.addEventListener('click', async (event) => {
    handleButtonClick(event);
    checkSomeStuff();
  });
});

audioControl.addEventListener('click', function(event) {
  if(isMuteActive === false) {
    this.classList.remove('audio--on');
    this.classList.add('audio--off');

    localStorage.setItem('isAudioMuted', JSON.stringify(true));
    isMuteActive = true;
    backgroundAudio.volume = 0;
    clickAudio.volume = 0;
  } else {
    this.classList.remove('audio--off');
    this.classList.add('audio--on');
  
    localStorage.setItem('isAudioMuted', JSON.stringify(false));
    isMuteActive = false;
    backgroundAudio.volume = 0.15;
    clickAudio.volume = 0.35;
  }
})

document.addEventListener('click', () => {
  if(!isMuteActive) {
    backgroundAudio.play();
  }
});

// Decoration and fun stuff 🤡
const runConsoleAdvisor = () => {
  const FRONTEND_DEV_ACTIVITIES = shuffleArray([
    'Visit Toronto JS event',
    'Learn a new JavaScript framework',
    'Read a book on modern web design',
    'Practice CSS animations',
    'Build a responsive website from scratch',
    'Contribute to an open-source project',
    'Practice coding challenges on platforms like HackerRank',
    'Master the use of browser developer tools',
    'Stay updated with latest web standards',
    'Improve website accessibility',
    'Watch a course on UX/UI design principles',
    `Create a personal project using a technology you're not familiar with`,
    'Join a local developer community or online group',
    'Understand the basics of backend development',
    'Learn about performance optimization techniques',
    'Develop a Progressive Web App (PWA)',
    'Read and write technical blogs',
    'Learn and apply test-driven development (TDD)',
    'Understand the basics of version control using Git',
    'Familiarize yourself with design tools like Sketch or Figma',
    'Master CSS preprocessors like Sass or Less',
    'Participate in a coding bootcamp',
    'Review the code of experienced developers',
    'Work on your portfolio website',
    'Try pair programming with a fellow developer',
    'Learn a server-side language like Node.js',
    'Understand the fundamentals of SEO',
    'Learn about RESTful APIs and GraphQL',
    'Master modern CSS layout with Flexbox and Grid',
    'Study the principles of clean code and apply them',
    'Get comfortable with a package manager like npm or Yarn',
    'Teach coding to others; it improves your understanding too',
    'Get familiar with CI/CD concepts',
    'Learn how to use Docker for containerization',
    'Explore cloud platforms like AWS, Azure, or GCP',
    'Understand the importance of website security',
    'Learn about different database technologies',
    'Master state management patterns',
    'Get a solid understanding of data structures and algorithms',
    'Attend web development seminars or workshops',
    'Improve your problem-solving skills'
  ]);
 
  const COLORS = ['#165b33', '#146b3a', '#f8b229', '#ea4630', '#bb2528', '#990000', '#FF5B00', '#D4D925', '#003366', '#800080', '#006400', '#8B0000', '#2F4F4F', '#00008B', '#008B8B', '#556B2F', '#FF8C00', '#9932CC', '#8B008B', '#483D8B'];
  const EMOJIS = [, '💻', '🖥️', '⌨️', '🖱️', '📱', '🖲️', '💾', '💿', '📡', '🔌', '🔋', '💡', '🔧', '🔬', '🕹️', '🎮', '👾', '🎧', '🤖', '🚀', '🛠️', '📚', '🧠', '👓', '🧮', '🔭', '📊', '📈', '🔒', '🔑'];

  console.log('%cHow to become a better developer?', 'color: green; font-family:"Roboto", monospace; font-size: 24px; font-weight: bold;');

  let pointer = 0;

  setInterval(() => {
    if(FRONTEND_DEV_ACTIVITIES.length === pointer) {
      pointer = 0;
    }

    const activity = FRONTEND_DEV_ACTIVITIES[pointer];

    console.log(`%c${getRandomElementFromArray(EMOJIS)} ${activity} ${getRandomElementFromArray(EMOJIS)}`,`color: ${getRandomElementFromArray(COLORS)}; font-family:'JetBrains Mono', monospace; font-size: 16px`);

    pointer++;
  }, 1500);
}

function animatePinnacle() {
  const pinnacles = Array.from(document.querySelectorAll('[id^="pinnacle-"]'));

  const activePinnacleIdx = pinnacles.findIndex(node => node.classList.contains('active'));
  const nextActivePinnacleIdx = activePinnacleIdx + 1 === pinnacles.length ? 0 : activePinnacleIdx + 1;

  const activePinnacle = pinnacles[activePinnacleIdx];
  const nextActivePinnacle = pinnacles[nextActivePinnacleIdx];

  activePinnacle.classList.remove('active');
  nextActivePinnacle.classList.add('active');
};

setInterval(animatePinnacle, 1000);
runConsoleAdvisor();

// Utils
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
};

function getRandomElementFromArray(array){
  return array[Math.floor(Math.random() * array.length)];
};
